import { StyledChip, StyledRightPage } from "./styles";
import { Box, Stack, Typography } from "@mui/material";
import SuccessSVGMailDark from "src/icons/SuccessSVGMailDark";
import { helperChipsOptions } from "./utils";
import { SuccessMobileHeader } from "./SuccessMobileHeader";
import { trackEvent } from "src/Amplitude";
import useFilterState from "./useFilterState";
import { NeonIcon } from "src/icons/NeonIcon";

export default function SubscribeRightSuccessComponent() {
  const [filteredOptions] = useFilterState();

  return (
    <StyledRightPage
      id="after-signup-success-subscription"
      item
      xs={12}
      md={6}
      justifyContent={{ sx: "start", md: "center" }}>
      <SuccessMobileHeader />
      <Box sx={{ padding: { xs: "40px 0px", md: "40px 40px 20px 40px" } }}>
        <Typography
          fontSize={{ sm: "16px", md: "28px" }}
          fontWeight="500"
          align="center"
          color="white">
          You are now subscribed to the following mail from Caleb & Brown.
        </Typography>
        <div style={{ display: "flex", justifyContent: "center", paddingTop: "20px" }}>
          <SuccessSVGMailDark />
        </div>
      </Box>
      <Box>
        {filteredOptions
          .filter((el) => el.subscribed)
          .map((el) => (
            <Stack direction="row" spacing={1} alignSelf={"center"} m={1}>
              <div style={{ alignSelf: "center", display: "flex" }}>
                <NeonIcon />
              </div>
              <Typography fontSize="16px" fontWeight="500" align="center" color="white">
                {el.label}
              </Typography>
            </Stack>
          ))}
      </Box>
      <Box
        sx={{
          bottom: { xs: "0", md: "0" },
          position: { xs: "none", md: "fixed" },
          marginBottom: { xs: "none", md: "40px" },
          marginTop: { xs: "64px", md: "none" },
        }}>
        <Typography fontSize="16px" fontWeight="500" align="center" color="white">
          Some quick How to tips for using our Portal:
        </Typography>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          textAlign={"center"}
          justifyContent="center"
          flexWrap="wrap"
          mt={1}>
          {helperChipsOptions.map((item) => (
            <Box sx={{ padding: { xs: "12px", sm: "4px" } }}>
              <StyledChip
                variant="outlined"
                mode="dark"
                onClick={() => {
                  trackEvent(
                    "User clicked on helper articles after subscribe",
                    { title: item.title, redirectedTo: item.url },
                    "Subscribe",
                  );
                  window.open(item.url);
                }}>
                {item.title}
              </StyledChip>
            </Box>
          ))}
        </Stack>
      </Box>
    </StyledRightPage>
  );
}
